jQuery(function() {
    //get the element found on the page
    var $goToTop = jQuery('[data-gototop]');

    //check if off top
    var activate_goToTop = function() {
        var top = window.pageYOffset || document.documentElement.scrollTop

        if (!$goToTop.hasClass('active')) {
            if (top > 200) {
                $goToTop.addClass('active');
            }
        } else if ($goToTop.hasClass('active')) {
            if (top < 200) {
                $goToTop.removeClass('active');
            }
        }
    }

    //primary method to set up sliders from dom
    var setup = function($element) {
        $element.on('click', () => {
            jQuery("html, body").animate({
                scrollTop: 0
            }, 200);
        });
        //add scroll listener and check before scroll
        window.addEventListener('scroll', activate_goToTop);
        activate_goToTop();
    };

    //run set up
    setup($goToTop);
});
